export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-cover-8ea0a66613f6ab43abccbb02425821c3.png";